import { getAnswerVerion, getzdChildV2 } from '../../api/dictionary'
import { getVersionListFromJSON } from '../../api/setting'
import * as loacalDictionary from '../../static/js/data'
import { localData } from '@/static/js/LocalData'
export default {
  namespaced: true,
  state: {
    data: {
      bookCategory: loacalDictionary.bookCategory,
      bookVersionList: [], // 图书版本字典
      bookCourses: [], // 图书科目字典
      answerVersion: [],
      'answercard.basicbook.volume': [
        { chName: '上册', value: 1 },
        { chName: '下册', value: 2 },
        { chName: '全一册', value: 3 }
      ]
    },
    settingGrade: [],
    settingCourses: [],
    ...loacalDictionary
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    SET_DISTIONAY(state, payload) {
      const pureObj = JSON.parse(JSON.stringify(payload))
      Object.keys(pureObj).forEach((key) => {
        state.data[key] = pureObj[key]
        localData.save(key, pureObj[key])
      })
    },
    setBookVersion(state, data) {
      state.bookVersionList = data
    },
    SET__COURSES(state, data) {
      state.bookCourses = data
    },
    SET_SETTING_GRADE(state, data) {
      state.settingGrade = data
    },
    SET_SETTING_COURSES(state, courses) {
      state.settingCourses = courses
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {
    // 获取图书字典
    async getZidian({ commit, dispatch, rootGetters }) {
      const { appid } = rootGetters
      const parentIdBookVersion = 'answercard.basicbook.version'
      const parentIdSettingGrade = `answercard.userPrefer.setting.grade.${appid}`
      const parentIdBookCourses = 'answercard.basicbook.course'

      const res = await getzdChildV2(
        [parentIdBookVersion, parentIdSettingGrade, parentIdBookCourses].map((parentId) => ({
          parentId,
          recursiveTimes: 1
        }))
      )

      // 版本字典
      commit('SET__COURSES', res.data.data[parentIdBookCourses])
      commit('setBookVersion', res.data.data[parentIdBookVersion])
      commit('SET_SETTING_GRADE', res.data.data[parentIdSettingGrade])
    },
    // mopa 字典
    async getDictionaryData({ commit, state, rootState }, payload) {
      const v2options = payload.map((i) => {
        if (i.parentId) {
          return i
        } else {
          return { parentId: i, recursiveTimes: 1 }
        }
      })
      const notHaveKeys = []
      for (const option of v2options) {
        const key = option.parentId
        state.data[key] = state.data[key] || (await localData.get(key))
        if (!state.data[key]) {
          notHaveKeys.push(option)
        }
      }
      if (notHaveKeys.length > 0) {
        const { data } = await getzdChildV2(notHaveKeys)
        if (data.status === 200) {
          commit('SET_DISTIONAY', data.data)
        }
      }
      return v2options.reduce((prev, curr) => {
        prev[curr.parentId] = state.data[curr.parentId]
        return prev
      }, {})
    },
    // 获得书籍版本
    async getCouresVersionListFromJSON({ commit, state, rootGetters }, grade) {
      const { appid } = rootGetters
      const { courses } = await getVersionListFromJSON(appid, grade)
      commit('SET_SETTING_COURSES', courses)
      return courses
    },
    // 答案页version筛选
    async getAnswerVersion({ commit, state }) {
      const {
        data: { answerVersion }
      } = state
      if (answerVersion.length > 0) {
        return answerVersion
      }
      const res = await getAnswerVerion()
      commit('SET_DISTIONAY', {
        answerVersion: res.data
      })
      return res.data
    }
  }
}
